import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';
import Button from 'components/base/Button';
import FeatherIcon from 'feather-icons-react';
import DomainCatalogBootstrap from 'components/bootstrap/DomainCatalogBootstrap';
import { MEGA_MENU_PRODUCTS } from 'components/navbars/navbar-horizontal/TopNavMegaMenu';
import { setCookie } from 'app/shared/utils/cookie.utils';

const ACTIVE_PRODUCT_COOKIE = 'activeProduct';

const ProductSelection = () => {
  const navigate = useNavigate();
  const userId = localStorage.getItem('userId') || '';

  const handleSelect = (productId: string) => {
    setCookie(ACTIVE_PRODUCT_COOKIE, productId);
    localStorage.removeItem('projectId');
    switch (productId) {
      case 'CSA+':
        navigate('/csa+/all-projects');
        break;
      case 'TSC+':
        navigate(`/project/${userId}/all-projects`);
        break;
      case 'MTC+':
        navigate('/mtc+/all-projects');
        break;
      case 'ATE+':
        navigate('/ate+/all-projects');
        break;
      default:
        navigate(`/project/${userId}/all-projects`);
    }
  };

  return (
    <>
      <DomainCatalogBootstrap />
      <div className="min-vh-100 d-flex flex-column align-items-center" style={{ backgroundColor: '#ffffff' }}>
        <Container className="flex-grow-1 d-flex flex-column justify-content-center py-5" style={{ maxWidth: '900px' }}>
          <button
            type="button"
            onClick={() => navigate('/')}
            className="border-0 bg-transparent p-0 mb-2 align-self-start"
            style={{ cursor: 'pointer', color: '#000' }}
            aria-label="Go back"
          >
            <FeatherIcon icon="arrow-left" size={24} />
          </button>
          <h2 className="mb-4 fw-light">Select the Product</h2>
          <Row xs={1} md={2} lg={2} xl={4} className="g-4">
            {MEGA_MENU_PRODUCTS.map((product, idx) => (
              <Col key={product.id}>
                <div
                  className="card h-100 border-0 d-flex flex-column product-card-fade-in-down"
                  style={{
                    minHeight: '220px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.06)',
                    animationDelay: `${idx * 0.1}s`
                  }}
                >
                  <div className="card-body d-flex flex-column flex-grow-1">
                    <div className="mb-3">
                      <FeatherIcon
                        icon={(product.icon as any) || 'box'}
                        size={24}
                        style={{ color: product.iconColor || '#6b7280' }}
                      />
                    </div>
                    <h5 className="card-title fw-bold mb-2">{product.title}</h5>
                    <p className="card-text text-body-secondary flex-grow-1" style={{ fontSize: '0.9375rem' }}>
                      {product.description}
                    </p>
                    <Button
                      variant="primary"
                      className="mt-auto align-self-start"
                      onClick={() => handleSelect(product.id)}
                    >
                      Select
                    </Button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </>
  );
};

export default ProductSelection;
